import React, { useState, useEffect } from 'react';
import './VideoSettings.css';

const VideoSettings = () => {
  const [settings, setSettings] = useState(() => {
    const saved = localStorage.getItem('videoSettings');
    return saved ? JSON.parse(saved) : {
      questionsByScene: false,
      clarifyingQuestions: false,
      questionType: 'none' // can be 'openEnded' or 'multipleChoice' or 'none'
    };
  });

  useEffect(() => {
    localStorage.setItem('videoSettings', JSON.stringify(settings));
  }, [settings]);

  const handleToggle = (setting) => {
    if (setting === 'openEnded' || setting === 'multipleChoice') {
      setSettings(prev => ({
        ...prev,
        questionType: prev.questionType === setting ? 'none' : setting
      }));
    } else {
      setSettings(prev => ({
        ...prev,
        [setting]: !prev[setting]
      }));
    }
  };

  return (
    <div className="video-settings-container">
      <h2>Video Settings</h2>
      <div className="settings-group">
        <div className="setting-item">
          <label>Questions by Scene</label>
          <div 
            className={`toggle ${settings.questionsByScene ? 'active' : ''}`}
            onClick={() => handleToggle('questionsByScene')}
          >
            <div className="toggle-slider"></div>
          </div>
        </div>

        <div className="setting-item">
          <label>Clarifying Questions at End</label>
          <div 
            className={`toggle ${settings.clarifyingQuestions ? 'active' : ''}`}
            onClick={() => handleToggle('clarifyingQuestions')}
          >
            <div className="toggle-slider"></div>
          </div>
        </div>

        <div className="question-type-group">
          <h3>Question Type</h3>
          <div className="setting-item">
            <label>Open-Ended Questions</label>
            <div 
              className={`toggle ${settings.questionType === 'openEnded' ? 'active' : ''}`}
              onClick={() => handleToggle('openEnded')}
            >
              <div className="toggle-slider"></div>
            </div>
          </div>

          <div className="setting-item">
            <label>Multiple Choice Questions</label>
            <div 
              className={`toggle ${settings.questionType === 'multipleChoice' ? 'active' : ''}`}
              onClick={() => handleToggle('multipleChoice')}
            >
              <div className="toggle-slider"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoSettings; 